module.exports = " <section id=about _v-056f0672=\"\"> <div class=row _v-056f0672=\"\"> <div class=columns _v-056f0672=\"\"> <h4 _v-056f0672=\"\">{{ conf.menu.about }}</h4> <div class=about-wrapper _v-056f0672=\"\"> <div class=row v-bind:class=\"$index == 0 ? 'single' : ''\" v-for=\"abouts in conf.abouts\" _v-056f0672=\"\"> <avatar v-for=\"detail in abouts\" :detail=detail :type=type _v-056f0672=\"\"></avatar> </div> </div> </div> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-056f0672!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
 ** module id = 57
 ** module chunks = 1
 **/